import PropTypes from 'prop-types';
import * as analytics from 'Utils/analytics';
import IconSvg from 'Components/IconSvg';
const { EVENTS } = analytics;

const formatVideoDuration = (strings, duration) => {
  const hours = ~~(duration / 3600);
  let minutes = ~~(duration / 60) - hours * 60;
  let msg = `${hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
  if (!hours) msg = `${minutes}`;
  if (!hours && !minutes) msg = '1';
  return `${msg} ${strings.min}`;
};

const formatMetadata = ({ strings, videoDurationSeconds }) => {
  const metadata = videoDurationSeconds
    ? formatVideoDuration(strings, videoDurationSeconds)
    : '';
  return (
    <p className="recommendations-item__meta">
      <span>{metadata}</span>
    </p>
  );
};

const RecommendationsItem = ({
  id,
  imageSrc,
  interestsBased,
  isFavorite,
  isVideo,
  onFavorite,
  tag,
  title,
  strings,
  style,
  url,
  videoDurationSeconds,
}) => {
  const handleClick = () => {
    const analyticsEvent = interestsBased
      ? EVENTS.selectInterestsRecommendationsItem
      : EVENTS.selectRecommendationsItem;
    analytics.event({ action: analyticsEvent, label: id });
  };

  const handleAddFavorite = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const analyticsEvent = interestsBased
      ? EVENTS.addInterestsRecommendationToLibrary
      : EVENTS.addRecommendationToLibrary;
    analytics.event({ action: analyticsEvent, label: id });
    onFavorite(id);
  };

  return (
    <a
      className={`recommendations-item ${isVideo ? '--video' : ''}${
        isFavorite ? ' --favorite' : ''
      }`}
      href={url}
      onClick={handleClick}
      style={style}
    >
      <div className="recommendations-item__media">
        <img alt={title} title={title} src={imageSrc} />
        <button
          className="recommendations-item__favorite-button"
          onClick={handleAddFavorite}
        >
          <IconSvg type="star" title="Add to library" />
        </button>
        {isVideo &&
          formatMetadata({
            strings,
            videoDurationSeconds,
          })}
      </div>
      <div className="recommendations-item__content">
        <p className="recommendations-item__title">{title}</p>
        {tag && <label className="recommendations-item__tag">{tag}</label>}
      </div>
    </a>
  );
};

RecommendationsItem.propTypes = {
  id: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  interestsBased: PropTypes.bool,
  isFavorite: PropTypes.bool,
  isVideo: PropTypes.bool.isRequired,
  onFavorite: PropTypes.func.isRequired,
  tag: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  strings: PropTypes.object.isRequired,
  style: PropTypes.object,
  url: PropTypes.string.isRequired,
  videoDurationSeconds: PropTypes.number,
};

RecommendationsItem.defaultProps = {
  interestsBased: false,
  isFavorite: false,
  style: {},
};

export default RecommendationsItem;
